import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { addPublicCustomClassNamePrefix } from '../utils/add-class-prefix'

export const CourseContentSkeleton = ({ className }: { className?: string }): ReactNode => (
  <div
    className={twMerge(
      'h-[80vh] w-full animate-pulse rounded-md bg-THEME-disabled',
      className,
      addPublicCustomClassNamePrefix('course__content-skeleton'),
    )}
  />
)
